export default {
  data() {
    return {
      sessions: [
        {
          title: "Dashboard - Admin",
          description: "Visão geral sobre o dashboard do admin",
          link: "/docs/dashboard-admin",
          user: "admin",
        },
        {
          title: "Lojas - Gerenciar",
          description: "Documentação sobre a aba gerenciar do admin",
          link: "/docs/lojas/gerenciar",
          user: "admin",
        },
        {
          title: "Lojas - Segmento",
          description: "Documentação sobre a aba segmento do admin",
          link: "/docs/lojas/segmento",
          user: "admin",
        },
        {
          title: "Lojas - Consumidor",
          description: "Documentação sobre a aba consumidor do admin",
          link: "/docs/lojas/consumidor",
          user: "admin",
        },
        {
          title: "Lojas - Usuários",
          description: "Documentação sobre a aba usuários do admin",
          link: "/docs/dashboard-lojista",
          user: "admin",
        },
        {
          title: "Lojas - Regras de Pagamento",
          description: "Documentação sobre a aba regras de pagamento do admin",
          link: "/docs/lojas/regraspag",
          user: "admin",
        },
        {
          title: "Vendas - Admin",
          description: "Documentação sobre a listagem de vendas do admin",
          link: "/docs/gerenciar-admin",
          user: "admin",
        },
        {
          title: "Cupons de Desconto - Admin",
          description: "Documentação sobre cupons de desconto do admin",
          link: "/docs/vendas/cupons",
          user: "admin",
        },
        {
          title: "Pacotes de Ingressos - Admin",
          description: "Documentação sobre pacotes de ingressos do admin",
          link: "/docs/vendas/pacotes",
          user: "admin",
        },
        {
          title: "Produtos - Gerenciar Admin",
          description: "Visão geral sobre o gerenciar produtos do admin",
          link: "/docs/produtos/gerenciar-admin",
          user: "admin",
        },
        {
          title: "Termos - Admin",
          description: "Detalhes sobre os termos do admin",
          link: "/docs/termos",
          user: "admin",
        },
        {
          title: "Financeiro - Regionais",
          description: "Documentação sobre a aba financeiro regionais do admin",
          link: "/docs/financeiro/regionais",
          user: "admin",
        },
        {
          title: "Financeiro - Formas de Pagamento",
          description:
            "Documentação sobre a aba financeiro formas de pagamento do admin",
          link: "/docs/financeiro/forma-de-pagamento",
          user: "admin",
        },
        {
          title: "Pessoas - Pontos de Venda",
          description:
            "Documentação sobre a aba pessoas pontos de venda do admin",
          link: "/docs/pessoas/pontos-de-venda",
          user: "admin",
        },
        {
          title: "Pessoas - Tipos de Pontos de Venda",
          description:
            "Documentação sobre a aba pessoas tipos de pontos de venda do admin",
          link: "/docs/pessoas/tipos-pontos-de-venda",
          user: "admin",
        },
        {
          title: "Pessoas - Usuários",
          description: "Documentação sobre a aba pessoas usuários do admin",
          link: "/docs/pessoas/usuarios",
          user: "admin",
        },
        {
          title: "Operações - Equipamentos",
          description:
            "Documentação sobre a aba operações equipamentos do admin",
          link: "/docs/operacoes/equipamentos",
          user: "admin",
        },
        {
          title: "Marketing - Configurações",
          description:
            "Documentação sobre a aba marketing configurações do admin",
          link: "/docs/marketing",
          user: "admin",
        },
        {
          title: "Relatórios - Analíticos",
          description:
            "Documentação sobre a aba relatórios analíticos do admin",
          link: "/docs/relatorios/analitico-admin",
          user: "admin",
        },
        {
          title: "Relatórios - Sintéticos",
          description:
            "Documentação sobre a aba relatórios sintéticos do admin",
          link: "/docs/relatorios/sintetico-admin",
          user: "admin",
        },
        {
          title: "Configurações - Ambientes",
          description:
            "Documentação sobre a aba configurações omnichannel do admin",
          link: "/docs/configuracoes/ambientes",
          user: "admin",
        },

        // Documentação Lojista e apps

        {
          title: "Dashboard - Lojista",
          description: "Visão geral sobre o dashboard do lojista",
          link: "/docs/dashboard-lojista",
          user: "loja",
        },
        {
          title: "Dados da Loja - Dados Cadastrais",
          description: "Documentação sobre a aba dados cadastrais do lojista",
          link: "/docs/dados-da-loja/dados-cadastrais",
          user: "loja",
        },
        {
          title: "Consumidores - Lojista",
          description: "Documentação sobre a aba Consumidores do lojista",
          link: "/docs/consumidores",
          user: "loja",
        },
        {
          title: "Usuários - Lojista",
          description: "Documentação sobre a aba usuários do lojista",
          link: "/docs/usuarios",
          user: "loja",
        },
        {
          title: "Vendas - Lojista",
          description: "Documentação sobre a aba vendas do lojista",
          link: "/docs/gerenciar",
          user: "loja",
        },
        {
          title: "Vendas - Cupons de Desconto",
          description: "Documentação sobre cupons de desconto do lojista",
          link: "/docs/vendas/cuponslojista",
          user: "loja",
        },
        {
          title: "Vendas - Pacotes de Ingressos",
          description: "Documentação sobre pacotes de ingressos do lojista",
          link: "/docs/vendas/cuponslojista",
          user: "loja",
        },
        {
          title: "Produtos - Gerenciar",
          description: "Documentação sobre a aba produtos gerenciar do lojista",
          link: "/docs/produtos/gerenciar",
          user: "loja",
        },
        {
          title: "Produtos - Regras de acesso e Período de vendas",
          description:
            "Documentação sobre a aba produtos regras de acesso e período de vendas do lojista",
          link: "/docs/produtos/regras-e-periodos",
          user: "loja",
        },
        {
          title: "Produtos - Ingressos",
          description: "Documentação sobre a aba produtos ingressos do lojista",
          link: "/docs/produtos/ingressos",
          user: "loja",
        },
        {
          title: "Relatórios - Analíticos e Sintéticos",
          description:
            "Documentação sobre a aba relatórios analíticos e sintéticos do lojista",
          link: "/docs/relatorios",
          user: "loja",
        },
        {
          title: "POS - Inicialização do equipamento",
          description:
            "Documentação sobre a aba inicialização do equipamento da POS",
          link: "/docs/inicializacao-pos",
          user: "loja",
        },
        {
          title: "POS - Tela inicial",
          description: "Documentação sobre a aba tela inicial da POS",
          link: "/docs/tela-inicial-pos",
          user: "loja",
        },
        {
          title: "POS - Processo de compra",
          description: "Documentação sobre a aba processo de compra da POS",
          link: "/docs/processo-compra-pos",
          user: "loja",
        },
        {
          title: "POS - Outras opções",
          description: "Documentação sobre a aba outras opções da POS",
          link: "/docs/outras-opt-pos",
          user: "loja",
        },
        {
          title: "POS Admin - Acesso",
          description: "Documentação sobre a aba acesso da POS Admin",
          link: "/docs/acesso-pos-admin",
          user: "admin",
        },
        {
          title: "POS Admin - Dados",
          description: "Documentação sobre a aba dados da POS Admin",
          link: "/docs/dados-pos-admin",
          user: "admin",
        },
        {
          title: "POS Admin - Geral",
          description: "Documentação sobre a aba geral da POS Admin",
          link: "/docs/geral-pos-admin",
          user: "admin",
        },
        {
          title: "Validator - Login",
          description: "Documentação sobre a aba login do Validator",
          link: "/docs/login-validator",
          user: "loja",
        },
        {
          title: "Validator - Processo de Validação",
          description:
            "Documentação sobre a aba processo de validação do Validator",
          link: "/docs/processo-validator",
          user: "loja",
        },
        {
          title: "Validator - Outras Opções",
          description: "Documentação sobre a aba outras opções do Validator",
          link: "/docs/outras-opt-validator",
          user: "loja",
        },
      ],
    };
  },
};
